// src/pages/yachts/special-offers/SimulateDrawer.js
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { simulateSpecialOffer } from './redux/_actions';

const drawerStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    width: 420,
    height: '100vh',
    background: '#fff',
    borderLeft: '1px solid #ccd',
    boxShadow: '-4px 0 16px rgba(0,0,0,0.1)',
    padding: 20,
    overflowY: 'auto',
    zIndex: 1050
};

class SimulateDrawer extends React.Component {
    state = {
        date_from: '',
        date_to: '',
        booking_date: '',
        access_code: '',
        result: null,
        running: false,
        error: null,
        // Tracks whether the user has manually typed in date_from/date_to.
        // Once true we stop auto-syncing from props.
        userEdited: false
    };

    componentDidUpdate(prevProps) {
        // When the drawer opens (false → true), seed dates from the latest props.
        // Only if the user hasn't manually overridden them.
        if (this.props.open && !prevProps.open && !this.state.userEdited) {
            this.setState({
                date_from: this.props.initialFrom || '',
                date_to: this.props.initialTo || ''
            });
        }
    }

    run = () => {
        const { date_from, date_to, booking_date, access_code } = this.state;
        const body = { yacht_id: this.props.yachtId, date_from, date_to };
        if (booking_date) body.booking_date = booking_date;
        if (access_code) body.access_code = access_code;
        this.setState({ running: true, error: null });
        this.props
            .simulate(body)
            .then((result) => this.setState({ result, running: false }))
            .catch((err) =>
                this.setState({
                    error:
                        (err &&
                            err.response &&
                            err.response.data &&
                            err.response.data.message) ||
                        'Simulation failed',
                    running: false
                })
            );
    };

    set = (k) => (e) => {
        const next = { [k]: e.target.value };
        // Lock auto-sync once the user touches date_from/date_to.
        if (k === 'date_from' || k === 'date_to') next.userEdited = true;
        this.setState(next);
    };

    render() {
        if (!this.props.open) return null;
        const { result, error, running } = this.state;
        return (
            <div style={drawerStyle}>
                <div className="d-flex">
                    <h5 className="mb-0">Simulate</h5>
                    <button
                        type="button"
                        onClick={this.props.onClose}
                        className="close ml-auto"
                        aria-label="Close"
                    >
                        <span>&times;</span>
                    </button>
                </div>
                <p className="text-muted" style={{ fontSize: 12 }}>
                    Preview (bypasses publish window + active toggle)
                </p>
                <div className="form-group">
                    <label>Date from</label>
                    <input
                        type="date"
                        className="form-control"
                        value={this.state.date_from}
                        onChange={this.set('date_from')}
                    />
                </div>
                <div className="form-group">
                    <label>Date to</label>
                    <input
                        type="date"
                        className="form-control"
                        value={this.state.date_to}
                        onChange={this.set('date_to')}
                    />
                </div>
                <div className="form-group">
                    <label>Booking date (optional)</label>
                    <input
                        type="date"
                        className="form-control"
                        value={this.state.booking_date}
                        onChange={this.set('booking_date')}
                    />
                </div>
                <div className="form-group">
                    <label>Access code (optional)</label>
                    <input
                        type="text"
                        className="form-control"
                        value={this.state.access_code}
                        onChange={this.set('access_code')}
                    />
                </div>
                <Button color="primary" onClick={this.run} disabled={running}>
                    {running ? 'Running…' : 'Run simulation'}
                </Button>

                {error && <div className="alert alert-danger mt-3">{error}</div>}

                {result && (
                    <div className="mt-3">
                        {result.reason === 'no_valid_rate' && (
                            <div className="alert alert-warning">
                                No rate covers the requested dates.
                            </div>
                        )}
                        {!result.reason && (
                            <>
                                <h6>
                                    {result.eligible
                                        ? `Offer applies: ${result.applied_offer && result.applied_offer.name}`
                                        : 'No offer applies. Base price returned.'}
                                </h6>
                                <p>
                                    Original:{' '}
                                    {(result.currency || '').toUpperCase()}{' '}
                                    {result.original_price}
                                    <br />
                                    Discounted:{' '}
                                    {(result.currency || '').toUpperCase()}{' '}
                                    {result.discounted_price}
                                </p>
                                {result.breakdown &&
                                    result.breakdown.partial_application && (
                                        <div className="alert alert-info" style={{ fontSize: 12 }}>
                                            Applied partially:{' '}
                                            {result.breakdown.intersect_days} of{' '}
                                            {result.breakdown.days} booked days fall inside
                                            the offer window, so the saving is smaller than
                                            the headline discount.
                                        </div>
                                    )}
                                {result.breakdown && (
                                    <pre
                                        style={{
                                            background: '#f7f8fb',
                                            padding: 8,
                                            fontSize: 12
                                        }}
                                    >
                                        {JSON.stringify(result.breakdown, null, 2)}
                                    </pre>
                                )}
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    simulate: (body) => dispatch(simulateSpecialOffer(body))
});

export default connect(null, mapDispatchToProps)(SimulateDrawer);
